<template>
    <div class="rent-container">
      <div class="rent-card">
        
        <!-- Top Branding Section -->
        <header class="rent-header">
          <div class="main-badge">
            <div class="icon-bg">
              <!-- Transfer arrows SVG matching the center logo layout -->
              <svg viewBox="0 0 24 24" class="icon-transfer" fill="none" xmlns="http://w3.org">
                <path d="M4 8H17M17 8L13 4M17 8L13 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20 16H7M7 16L11 12M7 16L11 20" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <!-- Stacked overlay cash/security floating badge icon -->
            <div class="floating-badge">
                <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 9C12.1667 9 11.4583 8.70833 10.875 8.125C10.2917 7.54167 10 6.83333 10 6C10 5.16667 10.2917 4.45833 10.875 3.875C11.4583 3.29167 12.1667 3 13 3C13.8333 3 14.5417 3.29167 15.125 3.875C15.7083 4.45833 16 5.16667 16 6C16 6.83333 15.7083 7.54167 15.125 8.125C14.5417 8.70833 13.8333 9 13 9ZM6 12C5.45 12 4.97917 11.8042 4.5875 11.4125C4.19583 11.0208 4 10.55 4 10V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H20C20.55 0 21.0208 0.195833 21.4125 0.5875C21.8042 0.979167 22 1.45 22 2V10C22 10.55 21.8042 11.0208 21.4125 11.4125C21.0208 11.8042 20.55 12 20 12H6ZM8 10H18C18 9.45 18.1958 8.97917 18.5875 8.5875C18.9792 8.19583 19.45 8 20 8V4C19.45 4 18.9792 3.80417 18.5875 3.4125C18.1958 3.02083 18 2.55 18 2H8C8 2.55 7.80417 3.02083 7.4125 3.4125C7.02083 3.80417 6.55 4 6 4V8C6.55 8 7.02083 8.19583 7.4125 8.5875C7.80417 8.97917 8 9.45 8 10ZM19 16H2C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V3H2V14H19V16ZM6 10V2V10Z" fill="#0024AE"/>
                </svg>

            </div>
          </div>
          <h1 class="main-title">Harmonized Rent</h1>
          <p class="main-subtitle">Receive all your rent on one consistent schedule.</p>
        </header>
  
        <!-- Requirements Flag -->
        <section class="banner-alert">
          <div class="banner-icon">
            <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://w3.org">
              <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM10 17L5 12L6.4 10.6L10 14.2L17.6 6.6L19 8L10 17Z"/>
            </svg>
          </div>
          <div class="banner-text">
            <h2 class="banner-title">Requires Guaranteed Rent</h2>
            <p class="banner-desc">This feature is only available for properties already on Guaranteed Rent.</p>
          </div>
        </section>
  
        <!-- Benefits & Features Checklist List -->
        <main class="benefits-list">
          
          <div class="benefit-card">
            <div class="benefit-icon-wrapper blue-tint">
              <svg viewBox="0 0 24 24" class="b-icon" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                <line x1="16" y1="2" x2="16" y2="6"/>
                <line x1="8" y1="2" x2="8" y2="6"/>
                <line x1="3" y1="10" x2="21" y2="10"/>
                <circle cx="12" cy="16" r="1"/>
              </svg>
            </div>
            <div class="benefit-content">
              <h3 class="benefit-title">One Payment Date</h3>
              <p class="benefit-desc">Rent from all units on the same day.</p>
            </div>
          </div>
  
          <div class="benefit-card">
            <div class="benefit-icon-wrapper blue-tint">
              <svg viewBox="0 0 24 24" class="b-icon" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                <polyline points="17 6 23 6 23 12"/>
              </svg>
            </div>
            <div class="benefit-content">
              <h3 class="benefit-title">Better Cash Flow Planning</h3>
              <p class="benefit-desc">Easily track and manage your income.</p>
            </div>
          </div>
  
          <div class="benefit-card">
            <div class="benefit-icon-wrapper blue-tint">
              <svg viewBox="0 0 24 24" class="b-icon" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
                <path d="M12 6v6l4 2"/>
              </svg>
            </div>
            <div class="benefit-content">
              <h3 class="benefit-title">Less Stress</h3>
              <p class="benefit-desc">No more tracking multiple rent schedules.</p>
            </div>
          </div>
  
        </main>
  
        <!-- Bottom System Insights Recommendation -->
        <section class="recommendation-box">
          <div class="rec-header">
            <svg viewBox="0 0 24 24" class="sparkle-icon" fill="currentColor">
              <path d="M9 21.5L11.4 14.1L18.7 11.7L11.4 9.3L9 2L6.6 9.3L0.3 11.7L6.6 14.1L9 21.5ZM19 7L19.9 4.1L22.7 3.2L19.9 2.3L19 0.5L18.1 2.3L15.3 3.2L18.1 4.1L19 7Z"/>
            </svg>
            <span class="rec-tag">Recommended Payment Date</span>
          </div>
          <h4 class="rec-date">5th of each month</h4>
          <p class="rec-info">Based on your properties, the 5th is optimal for cashflow.</p>
        </section>

        <section class="workflow-section">
          <h2 class="section-title">How It Works</h2>
          
          <div class="timeline">
            <div v-for="(step, index) in steps" :key="index" class="timeline-item">
              <div class="timeline-badge">
                <span class="step-number">{{ step.number }}</span>
              </div>
              <div class="timeline-content">
                <p class="step-text">{{ step.text }}</p>
              </div>
            </div>
          </div>
        </section>

        <section class="checklist-card">
          <h3 class="checklist-header">After Harmonization:</h3>
          
          <ul class="checklist-items">
            <li v-for="(item, index) in checklist" :key="index" class="checklist-item">
              <div class="check-icon-wrapper">
                <!-- Verified Circle Check Blue SVG Icon -->
                <svg viewBox="0 0 24 24" class="svg-check-icon">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </div>
              <span class="item-label">{{ item }}</span>
            </li>
          </ul>
        </section>

        <div class="notice-box">
          <div class="notice-icon-wrapper">
            <!-- Information SVG Icon -->
            <svg viewBox="0 0 24 24" class="svg-info-icon">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
            </svg>
          </div>
          <div class="notice-content">
            <p class="notice-text">
              <strong>Activation Details:</strong> <br>
              Rent cycles adjusted (pro-rated if needed). <br>
              All units follow new schedule. <br>
              Payments sent to SAFE wallet.
            </p>
          </div>
        </div>
      
        <div class="button-holder">
          <button class="btn" @click="routeTo()">Continue</button>
        </div>
  
      </div>
    </div>
</template>

<script>
  export default {
    name: 'HomeHarmonized',
        data() {
            return {
                steps: [
                    { number: 1, text: 'Select a Guaranteed Rent property or units.' },
                    { number: 2, text: 'Choose a preferred payment date.' },
                    { number: 3, text: 'We align all tenant payments to that date.' },
                    { number: 4, text: 'You receive rent on a single schedule.' }
                ],
                checklist: [
                    'One consistent payment date',
                    'Improved financial visibility',
                    'Easier income tracking'
                ]
            };
        },
        beforeDestroy() {
          sessionStorage.removeItem('unitSelections');
        },
        methods: {
          goBack() {
            this.$router.go(-1)
          },
          routeTo() {
            this.$router.push("harmonized-rent-property");
          },
        }
  };
</script>

<style scoped lang="scss">


// Color Declarations
$bg-main: #f8fafd;
$card-white: #ffffff;
$color-bg-card: #ffffff;
$primary-blue: #0047ff;
$color-brand-blue: #0046ff;
$color-brand-light-blue: #eef2ff;
$color-brand-dark-blue: #0033EA;
$text-dark: #111625;
$text-muted: #58627a;
$alert-bg: #003ce6;
$tint-blue: #edf2ff;
$rec-bg: #E8E7F5;
$color-text-dark: #090e1a;
$color-bg-checklist: #e8ecfc;
$color-bg-notice: #f0f3fa;
$color-text-dark: #090e1a;
$color-text-muted: #4e5668;

// Main Structural Frame Wrapper
.rent-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: $bg-main;
  padding: 1.5rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
}

// Clean Fluid-width Mobile Layout Card
.rent-card {
  background-color: $card-white;
  width: 100%;
  max-width: 420px; 
  border-radius: 28px;
  padding: 2.2rem 1rem;
  //   box-shadow: 0 10px 30px rgba(0, 71, 255, 0.04);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.05), 0 12px 24px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

// Upper Logo Presentation Styles
.rent-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.5rem;

  .main-badge {
    position: relative;
    width: 110px;
    height: 110px;
    margin-bottom: 1.2rem;

    .icon-bg {
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, #4371ff, #0041eb);
      border-radius: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $card-white;
      box-shadow: 0 8px 20px rgba(0, 65, 235, 0.2);

      .icon-transfer {
        width: 48px;
        height: 48px;
        transform: rotate(-10deg);
      }
    }

    .floating-badge {
      position: absolute;
      bottom: -6px;
      right: -6px;
      width: 34px;
      height: 34px;
      background-color: $card-white;
      border-radius: 10px;
      border: 2px solid $card-white;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $card-white;
      padding: 5px;
    }
  }

  .main-title {
    font-size: 1.65rem;
    font-weight: 700;
    color: $text-dark;
    letter-spacing: -0.5px;
    margin-bottom: 0.5rem;
  }

  .main-subtitle {
    font-size: 0.98rem;
    color: $text-muted;
    line-height: 1.45;
    max-width: 85%;
  }
}

// Mid Banner Callout Wrapper
.banner-alert {
  background-color: $alert-bg;
  color: $card-white;
  border-radius: 16px;
  padding: 1.1rem;
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  box-shadow: 0 6px 15px rgba(0, 60, 230, 0.15);

  .banner-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .banner-text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: left;

    .banner-title {
      font-size: 1.05rem;
      font-weight: 600;
      letter-spacing: -0.2px;
    }

    .banner-desc {
      font-size: 0.85rem;
      opacity: 0.85;
      line-height: 1.4;
    }
  }
}

// Core Features Vertical Stack Grid 
.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;

  .benefit-card {
    background-color: $card-white;
    border: 1px solid rgba(0, 0, 0, 0.03);
    border-radius: 16px;
    padding: 1.1rem 0.5rem;
    display: flex;
    align-items: center;
    gap: 1.1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }

    .benefit-icon-wrapper {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;

      &.blue-tint {
        background-color: $tint-blue;
        color: $primary-blue;
      }

      .b-icon {
        width: 22px;
        height: 22px;
      }
    }

    .benefit-content {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      text-align: left;

      .benefit-title {
        font-size: 0.95rem;
        font-weight: 600;
        color: $text-dark;
      }

      .benefit-desc {
        font-size: 0.88rem;
        color: $text-muted;
        line-height: 1.35;
      }
    }
  }
}

// Lower Informational Insight Accent Box
.recommendation-box {
  background-color: $rec-bg;
  border-left: 4px solid $primary-blue;
  border-radius: 14px;
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  text-align: left;

  .rec-header {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    color: $primary-blue;

    .sparkle-icon {
      width: 15px;
      height: 15px;
    }

    .rec-tag {
      font-size: 0.82rem;
      font-weight: 700;
      text-transform: none;
      letter-spacing: -0.1px;
    }
  }

  .rec-date {
    font-size: 1.25rem;
    font-weight: 800;
    color: $text-dark;
    margin-top: 0.1rem;
  }

  .rec-info {
    font-size: 0.85rem;
    color: $text-muted;
    line-height: 1.4;
  }
}

// Media Breakpoint Adaptability Adjustments for Tablet & Larger Displays
@media (min-width: 480px) {
  .rent-card {
    padding: 2.5rem 2rem;
    max-width: 440px;
  }
}

// Workflow / Timeline Section Styling
.workflow-section {
    width: 100%;
    margin-top: 46px;
    .section-title {
      font-size: 24px;
      font-weight: 700;
      color: $color-text-dark;
      margin: 0 0 28px 0;
      letter-spacing: -0.3px;
      text-align: left;
      font-family: Lato;
    }

    .timeline {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 32px;
      padding-left: 6px;

      // Vertical connecting line running down steps
      &::before {
        content: '';
        position: absolute;
        top: 14px;
        left: 20px;
        bottom: 14px;
        width: 2px;
        background-color: #e2e8f5;
        z-index: 1;
      }

      .timeline-item {
        position: relative;
        display: flex;
        align-items: center;
        gap: 20px;
        z-index: 2;

        .timeline-badge {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background-color: $color-brand-blue;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0 4px 10px rgba($color-brand-blue, 0.2);

          .step-number {
            font-size: 14px;
            font-weight: 700;
            color: $color-bg-card;
          }
        }

        .timeline-content {
          .step-text {
            font-size: 17px;
            font-weight: 500;
            color: $color-text-dark;
            margin: 0;
            text-align: left;
            font-family: Lato;
          }
        }
      }
    }
  }

  // Requirements Checklist Box Styling
  .checklist-card {
    background-color: $color-bg-checklist;
    border-radius: 16px;
    padding: 24px 22px;
    box-shadow: 0 2px 12px rgba(0, 50, 150, 0.02);
    text-align: left;
    width: 100%;
    margin-top: 46px;
    margin-bottom: 30px;

    .checklist-header {
      font-size: 14px;
      font-weight: 700;
      color: #444656;
      letter-spacing: 0.8px;
      margin: 0 0 24px 0;
      font-family: Lato;
    }

    .checklist-items {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 18px;

      .checklist-item {
        display: flex;
        align-items: center;
        gap: 14px;


        .check-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;

          .svg-check-icon {
            width: 21px;
            height: 21px;
            fill: #16A34A;
          }
        }

        .item-label {
          font-size: 16px;
          font-weight: 500;
          color: #3b4254;
          font-family: Lato;
        }
      }
    }
  }


  // 3. Bottom Notice Alert Block Styling
  .notice-box {
    background-color: $color-bg-notice;
    border-radius: 12px;
    padding: 16px 18px;
    display: flex;
    gap: 12px;
    align-items: flex-start;

    .notice-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 2px;

      .svg-info-icon {
        width: 20px;
        height: 20px;
        fill: #16A34A;;
      }
    }

    .notice-content {
      flex: 1;

      .notice-text {
        font-size: 14px;
        line-height: 1.5;
        color: $color-text-muted;
        margin: 0;
        text-align: left;
        font-family: Lato;

        strong {
          color: $color-text-dark;
          font-weight: 600;
        }
      }
    }
  }

   // Media viewports optimization for minor adjustments
   @media (max-width: 400px) {
    .page-container {
      .workflow-section {
        .section-title {
          font-size: 22px;
        }
        .timeline .timeline-item .step-text {
          font-size: 15.5px;
        }
      }
      
      .checklist-card {
        padding: 20px 16px;
        
        .checklist-items .checklist-item .item-label {
          font-size: 15px;
        }
      }
    }
  }
  
  .button-holder {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    button {
      background-color: $color-brand-dark-blue;
      color: $color-bg-card;
      width: 100%;
      height: 50px;
      font-family: Lato;
      box-shadow: none;
      outline: 0;
    }
  }



</style>
  